import { clamp } from 'lodash'

/** Based on: https://stackoverflow.com/a/18650828, but uses Intl.NumberFormat */
export function formatBytes(bytes: number): string {
  const k = 1024;
  const units = [
    'byte',
    'kilobyte',
    'megabyte',
    'gigabyte',
    'terabyte',
    'petabyte',
  ];

  const i = clamp(
    Math.floor(Math.log(bytes) / Math.log(k)),
    0,
    units.length - 1
  );
  const value = bytes / Math.pow(k, i);

  const formatter = new Intl.NumberFormat(undefined, {
    style: 'unit',
    unit: units[i],
    unitDisplay: 'narrow',
  });

  return formatter.format(value);
}

export function formatBytesPerSecond(bytesPerSec: number): string {
  const k = 1024;
  const units = [
    'byte-per-second',
    'kilobyte-per-second',
    'megabyte-per-second',
    'gigabyte-per-second',
    'terabyte-per-second',
    'petabyte-per-second',
  ];

  const i = clamp(
    Math.floor(Math.log(bytesPerSec) / Math.log(k)),
    0,
    units.length - 1
  );
  const value = bytesPerSec / Math.pow(k, i);

  const formatter = new Intl.NumberFormat(undefined, {
    style: 'unit',
    unit: units[i],
    unitDisplay: 'narrow',
  });

  return formatter.format(value);
}
